import { Controller } from "@hotwired/stimulus"

// Live "next number" preview for one Nummernkreis card on the settings tab.
//
// The initial preview is rendered server-side, so this controller deliberately does
// NOT fetch on connect: all settings panels are in the DOM on every settings page
// load, and fetching here meant five requests fired no matter which tab you opened.
export default class extends Controller {
  static targets = ["format", "nextFigure", "preview"]
  static values = {
    url: String,
    errorText: String,
    delay: { type: Number, default: 250 },
  }

  disconnect() {
    clearTimeout(this.timer)
    this.abortController?.abort()
  }

  schedulePreview() {
    clearTimeout(this.timer)
    this.timer = setTimeout(() => this.updatePreview(), this.delayValue)
  }

  // Inserts a %TOKEN chip at the caret instead of making the user type it.
  insertToken(event) {
    const token = event.currentTarget.dataset.token
    const input = this.formatTarget
    const start = input.selectionStart ?? input.value.length
    const end = input.selectionEnd ?? input.value.length

    input.value = input.value.slice(0, start) + token + input.value.slice(end)
    const caret = start + token.length
    input.focus()
    input.setSelectionRange(caret, caret)

    this.schedulePreview()
  }

  async updatePreview() {
    // Abort the in-flight request so a slow earlier response cannot overwrite a newer one.
    this.abortController?.abort()
    this.abortController = new AbortController()

    const params = new URLSearchParams({
      next_number_format: this.formatTarget.value,
      next_figure: this.nextFigureTarget.value,
    })

    try {
      const response = await fetch(`${this.urlValue}?${params}`, {
        signal: this.abortController.signal,
        headers: { Accept: "text/plain" },
      })
      if (!response.ok) throw new Error(`Unexpected status ${response.status}`)

      this.previewTarget.textContent = await response.text()
      this.previewTarget.classList.remove("text-red-600")
    } catch (error) {
      if (error.name === "AbortError") return

      this.previewTarget.textContent = this.errorTextValue
      this.previewTarget.classList.add("text-red-600")
    }
  }
}
